import PinCheck from "components/ReportPage/PinCheck";
import ReportPageNew from "components/ReportPage/ReportPageNew";
import React, { useEffect, useState } from "react";

const REPORT_ACCESS_KEY = "tbcareer-report-access";

const ReportPage = () => {
  const [hasAccess, setHasAccess] = useState(() => {
    return sessionStorage.getItem(REPORT_ACCESS_KEY) === "true";
  });

  useEffect(() => {
    return () => {
      // Require the PIN again after leaving the report page
      sessionStorage.removeItem(REPORT_ACCESS_KEY);
    };
  }, []);

  const handlePinSuccess = () => {
    sessionStorage.setItem(REPORT_ACCESS_KEY, "true");
    setHasAccess(true);
  };

  if (!hasAccess) {
    return (
      <PinCheck
        correctPin="171284"
        onSuccess={handlePinSuccess}
        title="Enter Passcode"
        description="Enter your 6-digit PIN to access the reports"
      />
    );
  }

  return <ReportPageNew />;
};

export default ReportPage;
